// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.behavior-upgrade-modal-content {
    text-align: center !important;
    padding: 10px !important;
}

.behavior-upgrade-modal-icon {
    width: 64px !important;
    height: 64px !important;
    margin: 0 auto 20px !important;
    background: linear-gradient(135deg, #5616ea 0%, #7c3aff 100%) !important;
    border-radius: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: white !important;
}

.behavior-upgrade-modal-icon svg {
    width: 32px !important;
    height: 32px !important;
}

.behavior-upgrade-modal-title {
    font-size: 1.5rem !important;
    font-weight: 700 !important;
    color: #1a1a1a !important;
    margin: 0 0 12px 0 !important;
}

.behavior-upgrade-modal-description {
    font-size: 1rem !important;
    color: #666 !important;
    line-height: 1.5 !important;
    margin: 0 0 28px 0 !important;
    padding: 0 10px !important;
}

.behavior-upgrade-plan-info {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 16px !important;
    margin-bottom: 28px !important;
    flex-wrap: wrap !important;
}

.behavior-upgrade-plan-badge {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 4px !important;
    padding: 14px 24px !important;
    border-radius: 10px !important;
    min-width: 120px !important;
}

.behavior-upgrade-current-plan {
    background: #f5f5f5 !important;
    border: 2px solid #e0e0e0 !important;
}

.behavior-upgrade-next-plan {
    background: linear-gradient(135deg, #f0e7ff 0%, #e7d4ff 100%) !important;
    border: 2px solid #d4b3ff !important;
}

.behavior-upgrade-plan-label {
    font-size: 0.75rem !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    color: #888 !important;
    letter-spacing: 0.5px !important;
}

.behavior-upgrade-plan-name {
    font-size: 1.1rem !important;
    font-weight: 700 !important;
    color: #1a1a1a !important;
    text-align: center !important;
    word-wrap: break-word !important;
    max-width: 100% !important;
}

.behavior-upgrade-plan-limit {
    font-size: 0.85rem !important;
    color: #666 !important;
    font-weight: 500 !important;
}

.behavior-upgrade-arrow-icon {
    font-size: 1.5rem !important;
    color: #5616ea !important;
    font-weight: bold !important;
    flex-shrink: 0 !important;
}

.behavior-upgrade-button {
    background: linear-gradient(135deg, #5616ea 0%, #7c3aff 100%) !important;
    color: #ffffff !important;
    padding: 12px 32px !important;
    border: none !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    font-size: 1rem !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 4px 12px rgba(94, 27, 255, 0.3) !important;
    width: 100% !important;
    max-width: 280px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
}

.behavior-upgrade-button:hover {
    background: linear-gradient(135deg, #4a14d6 0%, #6328e6 100%) !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 16px rgba(94, 27, 255, 0.4) !important;
}

.behavior-upgrade-button:active {
    transform: translateY(0) !important;
}

.behavior-upgrade-contact-button {
    background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%) !important;
    box-shadow: 0 4px 12px rgba(45, 55, 72, 0.3) !important;
}

.behavior-upgrade-contact-button:hover {
    background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%) !important;
    box-shadow: 0 6px 16px rgba(45, 55, 72, 0.4) !important;
}

/* Optional secondary action under "Upgrade Now" (e.g. "Add the first N only"). */
.behavior-upgrade-secondary {
    margin-top: 10px;
    background: transparent;
    color: #5616ea;
    border: 1px solid #d9cffb;
    border-radius: 8px;
    padding: 10px 24px;
    font: inherit;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    max-width: 280px;
    transition: background 0.2s ease, border-color 0.2s ease;
}
.behavior-upgrade-secondary:hover { background: #f3efff; border-color: #5616ea; }
`, "",{"version":3,"sources":["webpack://./src/components/behaviorUpgradeModal.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wEAAwE;IACxE,8BAA8B;IAC9B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,wEAAwE;IACxE,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,oCAAoC;IACpC,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,wEAAwE;IACxE,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,wDAAwD;IACxD,sBAAsB;IACtB,2BAA2B;IAC3B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,wEAAwE;IACxE,sCAAsC;IACtC,wDAAwD;AAC5D;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wEAAwE;IACxE,uDAAuD;AAC3D;;AAEA;IACI,wEAAwE;IACxE,uDAAuD;AAC3D;;AAEA,iFAAiF;AACjF;IACI,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,wDAAwD;AAC5D;AACA,oCAAoC,mBAAmB,EAAE,qBAAqB,EAAE","sourcesContent":[".behavior-upgrade-modal-content {\r\n    text-align: center !important;\r\n    padding: 10px !important;\r\n}\r\n\r\n.behavior-upgrade-modal-icon {\r\n    width: 64px !important;\r\n    height: 64px !important;\r\n    margin: 0 auto 20px !important;\r\n    background: linear-gradient(135deg, #5616ea 0%, #7c3aff 100%) !important;\r\n    border-radius: 16px !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    color: white !important;\r\n}\r\n\r\n.behavior-upgrade-modal-icon svg {\r\n    width: 32px !important;\r\n    height: 32px !important;\r\n}\r\n\r\n.behavior-upgrade-modal-title {\r\n    font-size: 1.5rem !important;\r\n    font-weight: 700 !important;\r\n    color: #1a1a1a !important;\r\n    margin: 0 0 12px 0 !important;\r\n}\r\n\r\n.behavior-upgrade-modal-description {\r\n    font-size: 1rem !important;\r\n    color: #666 !important;\r\n    line-height: 1.5 !important;\r\n    margin: 0 0 28px 0 !important;\r\n    padding: 0 10px !important;\r\n}\r\n\r\n.behavior-upgrade-plan-info {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    gap: 16px !important;\r\n    margin-bottom: 28px !important;\r\n    flex-wrap: wrap !important;\r\n}\r\n\r\n.behavior-upgrade-plan-badge {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    align-items: center !important;\r\n    gap: 4px !important;\r\n    padding: 14px 24px !important;\r\n    border-radius: 10px !important;\r\n    min-width: 120px !important;\r\n}\r\n\r\n.behavior-upgrade-current-plan {\r\n    background: #f5f5f5 !important;\r\n    border: 2px solid #e0e0e0 !important;\r\n}\r\n\r\n.behavior-upgrade-next-plan {\r\n    background: linear-gradient(135deg, #f0e7ff 0%, #e7d4ff 100%) !important;\r\n    border: 2px solid #d4b3ff !important;\r\n}\r\n\r\n.behavior-upgrade-plan-label {\r\n    font-size: 0.75rem !important;\r\n    font-weight: 600 !important;\r\n    text-transform: uppercase !important;\r\n    color: #888 !important;\r\n    letter-spacing: 0.5px !important;\r\n}\r\n\r\n.behavior-upgrade-plan-name {\r\n    font-size: 1.1rem !important;\r\n    font-weight: 700 !important;\r\n    color: #1a1a1a !important;\r\n    text-align: center !important;\r\n    word-wrap: break-word !important;\r\n    max-width: 100% !important;\r\n}\r\n\r\n.behavior-upgrade-plan-limit {\r\n    font-size: 0.85rem !important;\r\n    color: #666 !important;\r\n    font-weight: 500 !important;\r\n}\r\n\r\n.behavior-upgrade-arrow-icon {\r\n    font-size: 1.5rem !important;\r\n    color: #5616ea !important;\r\n    font-weight: bold !important;\r\n    flex-shrink: 0 !important;\r\n}\r\n\r\n.behavior-upgrade-button {\r\n    background: linear-gradient(135deg, #5616ea 0%, #7c3aff 100%) !important;\r\n    color: #ffffff !important;\r\n    padding: 12px 32px !important;\r\n    border: none !important;\r\n    border-radius: 8px !important;\r\n    font-weight: 600 !important;\r\n    font-size: 1rem !important;\r\n    cursor: pointer !important;\r\n    transition: all 0.3s ease !important;\r\n    box-shadow: 0 4px 12px rgba(94, 27, 255, 0.3) !important;\r\n    width: 100% !important;\r\n    max-width: 280px !important;\r\n    display: inline-flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    gap: 8px !important;\r\n}\r\n\r\n.behavior-upgrade-button:hover {\r\n    background: linear-gradient(135deg, #4a14d6 0%, #6328e6 100%) !important;\r\n    transform: translateY(-2px) !important;\r\n    box-shadow: 0 6px 16px rgba(94, 27, 255, 0.4) !important;\r\n}\r\n\r\n.behavior-upgrade-button:active {\r\n    transform: translateY(0) !important;\r\n}\r\n\r\n.behavior-upgrade-contact-button {\r\n    background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%) !important;\r\n    box-shadow: 0 4px 12px rgba(45, 55, 72, 0.3) !important;\r\n}\r\n\r\n.behavior-upgrade-contact-button:hover {\r\n    background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%) !important;\r\n    box-shadow: 0 6px 16px rgba(45, 55, 72, 0.4) !important;\r\n}\r\n\r\n/* Optional secondary action under \"Upgrade Now\" (e.g. \"Add the first N only\"). */\r\n.behavior-upgrade-secondary {\r\n    margin-top: 10px;\r\n    background: transparent;\r\n    color: #5616ea;\r\n    border: 1px solid #d9cffb;\r\n    border-radius: 8px;\r\n    padding: 10px 24px;\r\n    font: inherit;\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    max-width: 280px;\r\n    transition: background 0.2s ease, border-color 0.2s ease;\r\n}\r\n.behavior-upgrade-secondary:hover { background: #f3efff; border-color: #5616ea; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
